@switch (step) {
  @case (STEPS.EDIT) {
    <saving-plans-edit (goNext)="step = STEPS.CONFIRM" (noWalletWarningClick)="handleNoWallet()" (resetAsset)="resetAsset()" />
  }
  @case (STEPS.CONFIRM) {
    <saving-plans-confirm (goBack)="goBack()" (confirm)="facade.updateSavingsPlan()" />
  }
}
